/*
Saikrishna 10/03/2022 2700753823 Global Field Bugs _350,347,349
Saikrishna 10/04/2022 2698403495 Fixed client maintenance and role management bugs JIra(229,232,33,34,49,56,58,393,94,95).
Prakash    26/10/2022 2698403495 Added classes for buttons.
Ashraf 11/16/2022 2700753823 disabling save button based on role access
Guru Prasad  11/24/2022 2698403495 fixed text-area fontsize and spacings
manikanta 01/06/2023 2698403495 fixed validation text
Prakash 02/13/2023 2698403495 Added New UI Style-classes for buttons.
suresh peddavoora 02/27/2023 2698403495 New UI changes
suresh peddavoora 02/28/2023 2698403495 New UI changes
Akhila 04/14/2023 2698403495 Added validation
Prakash 19-04-2023 2698403495 Removed padding issue in add note.
Ravi 06/22/2023 2698403495 fixed submit issue
sohel 09/27/2023 2698403495 save button disable issue fix
Sohel 10/27/2023 2698403495 Save button disable bug fix for all module
Sohel 10/30/2023 5314488544 Added Eligibilty Status Field conditionaly
Sohel 10/30/2023 5314488544 validation issue fixed
Sohel 10/30/2023 5314488544 removed status field and validation
Sohel 11/01/2023 5314488544 Added status field
Sohel 11/01/2023 5314488544 Added status field validation conditionaly
sohel 11/07/2023 5314488544 lookup api changes for reviewed status
*/

import React, {useState, useContext, useEffect, useCallback} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import { TextField, Button, FormHelperText, Tooltip, FormControl} from '@material-ui/core';
import {useSelector} from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import MicIcon from '@material-ui/icons/Mic';
import StopRoundedIcon from '@material-ui/icons/StopRounded';
import Filter from 'bad-words';
import {useUpdateEffect} from 'react-use';
import debounce from 'lodash.debounce';
import clsx from 'clsx';
import CloseIcon from '@material-ui/icons/Close';
import Check from '@material-ui/icons/Check';
import PageLoader from '../PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../CustomSnackBar';
import {profinityWords} from '../../util/ProfinityWord';
import {LANGUAGE_CODE, REGION} from '../../constants/ReusableConstants';
import {ThemeContext} from '../../themes/ThemeProvider';
// import {submissionStart} from '../../redux/reducers/CommonActions/commonActions';
import throttle from 'lodash/throttle';
import {REVIEW_STATUS } from "../../constants/Lookup";
import GuiTextField from '../FormComponents/GuiTextField';
import GuiAutoComplete from '../FormComponents/GuiAutoComplete';

const audioUtils = require('./audioUtils'); // for encoding audio data as PCM
const crypto = require('crypto'); // tot sign our pre-signed URL
const v4 = require('./aws-signature-v4'); // to generate our pre-signed URL
const marshaller = require('@aws-sdk/eventstream-marshaller'); // for converting binary event stream messages to and from JSON
const utilUtf8Node = require('@aws-sdk/util-utf8-node'); // utilities for encoding and decoding UTF8
const MicrophoneStream = require('microphone-stream'); // collect microphone input as a stream of raw bytes

// pre-signed url
const sampleRate = 44100;
const languageCode = LANGUAGE_CODE;
const region = REGION;
const {REACT_APP_ACCESS_KEY, REACT_APP_SECRET_KEY} = process.env;
let text = '';
// our converter between binary event streams messages and JSON
const eventStreamMarshaller = new marshaller.EventStreamMarshaller(
  utilUtf8Node.toUtf8,
  utilUtf8Node.fromUtf8,
);

function getAudioEventMessage(buffer) {
  // wrap the audio data in a JSON envelope
  return {
    headers: {
      ':message-type': {
        type: 'string',
        value: 'event',
      },
      ':event-type': {
        type: 'string',
        value: 'AudioEvent',
      },
    },
    body: buffer,
  };
}

export default function AddaNoteW8({
  transcription,
  setWebSocketOnClose,
  charLimitMsg,
  setCharLimitMsg,
  sidePanelNotes,
  dispatchRecordFormatSystemNotes,
  isLoading,
  eligibiltyScrubScreen,
  dropDownData
}) {
  const {labelColor} = useContext(ThemeContext);
  const useStyles = makeStyles((theme) => ({
    labelName: {
      '& .MuiOutlinedInput-input': {
        // padding: '11.3px 7px',
        fontSize: '12px !important',
        color: `${labelColor} !important`,
        paddingLeft: '0 !important',
      },
    },
    inputLabel: {
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '600',
      },
    },

    detailsText: {
      fontSize: '0.8rem',
      fontWeight: '500',
      backgroundColor: '#FFF',
      padding: 10,
      boxShadow:
        '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    },
    specialNeeds: {
      'position': 'relative',
      'display': 'flex',
      'justifyContent': 'flex-end',
      // 'margin': '10px !important',
      // 'padding': '10px 5px 5px',
      '& .MuiFormControl-marginDense': {
        marginTop: '0.5em !important',
        marginBottom: '0.25em !important',
      },
    },
    sidepanelSpecialNeeds: {
      'position': 'relative',
      'display': 'flex',
      'justifyContent': 'flex-end',
      // margin: "10px !important",
      'padding': '15px 10px 5px 10px',
      '&  .MuiFormControl-marginDense': {
        marginTop: '8px !important',
        marginBottom: '4px !important',
      },
    },
    micButton: {
      position: 'absolute',
      top: -20,
      right: '40px',
      alignItems: 'flex-start',

      minWidth: '30px !important',
      zIndex: 1,
      color: 'red',
    },
    stopButton: {
      position: 'absolute',
      top: -20,
      alignItems: 'flex-start',
      minWidth: '30px !important',
      zIndex: 1,
      color: 'blue',
    },
    buttonRoot: {
      'lineHeight': 1.75,
      [theme.breakpoints.down('md')]: {
        lineHeight: 1.5,
        padding: '6px 15px',
      },
      '& .MuiButton-label': {
        fontSize: '0.813rem',
        [theme.breakpoints.down('md')]: {
          fontSize: '0.688rem',
          letterSpacing: 1,
        },
      },
    },
    cancelIcon: {
      bottom: '243px',
      color: 'red',
      minWidth: '50px',
    },
    stopIcon: {
      bottom: '243px',
      color: 'blue',
      minWidth: '50px',
    },
    notesError: {
      '& .MuiFormHelperText-root': {
        bottom: '-10px !important',
        left: '10px !important',
        position: 'absolute',
      },
    },
    sidepanelMicButtonRight: {
      right: '214px',
    },
    sidepanelstopButtonRight: {
      right: '185px',
    },
    helperTxt: {
      color: 'blue',
      position: 'absolute',
      top: '205px',
      left: '10px',
    },
    sidepanelHelperTxt: {
      color: 'blue',
    },
    noteblock: {
      '& .MuiInputBase-root': {
        '& .MuiInputBase-inputMultiline ': {
          paddingLeft: '0 !important',
        },
      },
    },
  }));
  const useStyles2 = makeStyles((theme) => ({
    labelName: {
      '& .MuiOutlinedInput-input': {
        // padding: '11.3px 7px',
        fontSize: '13px',
        color: `${labelColor} !important`,
      },
    },
    inputLabel: {
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '600',
      },
    },

    detailsText: {
      fontSize: '0.8rem',
      fontWeight: '500',
      backgroundColor: '#FFF',
      padding: 10,
      boxShadow:
        '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    },
    specialNeeds: {
      'position': 'relative',
      'display': 'flex',
      'justifyContent': 'flex-end',
      // margin: "10px !important",
      'padding': '15px 10px 5px 10px',
      '&  .MuiFormControl-marginDense': {
        marginTop: '8px !important',
        marginBottom: '4px !important',
      },
    },
    micButton: {
      position: 'absolute',
      top: -8,
      alignItems: 'flex-start',
      minWidth: '30px !important',
      zIndex: 1,
      color: 'red',
    },
    stopButton: {
      position: 'absolute',
      top: -8,
      alignItems: 'flex-start',
      minWidth: '30px !important',
      zIndex: 1,
      color: 'blue',
    },

    iconButtons: {
      position: 'absolute',
      top: '72px !important',
      right: '-3px',
      alignItems: 'flex-start',
      minWidth: '30px !important',
      zIndex: 1,
      [theme.breakpoints.down('md')]: {
        top: '55px !important',
      },
    },

    micButtonleft: {
      right: '230px',
    },
    micButtonRight: {
      right: '40px',
    },
    stopButtonLeft: {
      right: '200px',
    },

    saveCheckIcon: {
      '& .MuiSvgIcon-root': {
        color: 'blue',
      },
    },
    iconWidth: {
      minWidth: 50,
    },
    cancelCloseIcon: {
      '& .MuiSvgIcon-root': {
        color: 'red',
      },
    },
    buttonRoot: {
      'lineHeight': 1.75,
      [theme.breakpoints.down('md')]: {
        lineHeight: 1.5,
        padding: '6px 15px',
      },
      '& .MuiButton-label': {
        fontSize: '0.813rem',
        [theme.breakpoints.down('md')]: {
          fontSize: '0.688rem',
          letterSpacing: 1,
        },
      },
    },

    notesError: {
      '& .MuiFormHelperText-root': {
        bottom: '-10px !important',
        left: '10px !important',
        position: 'absolute',
      },
    },
  }));
  const [cancel, setCancel] = useState(false);
  const [validateNotes, setValidateNotes] = useState(false);
  const [statusValidateData, setStatusValidateData] = useState(false)
  const [play, setPlay] = useState(false);
  // const dispatch = useDispatch();
  const {notesData, notesStatus, successMsg, errorMsg} = useSelector(({note}) => note);
  const {clientnotesStatus, clientisLoading, clientsuccessMsg, clienterrorMsg} = useSelector(
    ({clientNotes}) => clientNotes,
  );
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);

  useEffect(() => {
    reset(initialValues);
    if (notesStatus === 200) {
      setCharLimitMsg(false);
      setValidateNotes(false);
      stop(webSocket);
      setNotes('');
      transcription = '';
    }
    if (clientnotesStatus === 200) {
      setCharLimitMsg(false);
      setValidateNotes(false);
      stop(webSocket);
      setNotes('');
      transcription = '';
    }
  }, [notesStatus, clientnotesStatus]);
  const classes = useStyles();
  const classes1 = useStyles2();
  const initialValues = {
    addaNote: notesData && notesData.noteText ? notesData.noteText : "",
    eligibleStatus: "",
  };
  const { register, handleSubmit, errors, reset, control } = useForm({
    defaultValues: initialValues,
  });
  const handleGetData = (data, typeCode) => {
    let label = [];
    label =
     data && data[typeCode]
       ? [...data[typeCode]].sort((a, b) =>
         a.valueCode > b.valueCode ? 1 : b.valueCode > a.valueCode ? -1 : 0
       )
       : [];

    return label;
  };
  const filter = new Filter({ placeHolder: "*" });
  filter.addWords(...profinityWords);
  const [notes, setNotes] = useState('');
  useUpdateEffect(() => {
    if (cancel && notes?.length === 0) {
      setValidateNotes(false);
      setCancel(false);
    } else if (notes?.length === 0) {
      // setValidateNotes(true);
      // setCancel(false);
    } else {
      setValidateNotes(false);
    }
  }, [notes?.length]);
  const [webSocket, setWebSocket] = React.useState();
  const [inputSampleRate, setInputSampleRate] = React.useState();

  const handleEventStreamMessage = (messageJson) => {
    const results = messageJson.Transcript.Results;
    if (results.length > 0) {
      if (results[0].Alternatives.length > 0) {
        const transcript = decodeURIComponent(escape(results[0].Alternatives[0].Transcript));

        // if this transcript segment is final, add it to the overall transcription
        if (!results[0].IsPartial) {
          text = transcript.toLowerCase().replace(/\./g, '').replace('?', '').replace('!', '');
          transcription += filter.clean(text) + '\n';
          setNotes(`${notes ? notes : ''} ${transcription}`);
          setCharLimitMsg(true);
        }
      }
    }
  };

  const stop = (socket) => {
    if (socket) {
      socket.close();
      setPlay(false);
      setWebSocket(undefined);
    }
  };
  const convertAudioToBinaryMessage = (audioChunk) => {
    const raw = MicrophoneStream.toRaw(audioChunk);

    // if (raw == null) {
    //   return ;
    // }

    // downsample and convert the raw audio bytes to PCM
    const downsampledBuffer = audioUtils.downsampleBuffer(raw, inputSampleRate, sampleRate);
    const pcmEncodedBuffer = audioUtils.pcmEncode(downsampledBuffer);

    // add the right JSON headers and structure to the message
    const audioEventMessage = getAudioEventMessage(Buffer.from(pcmEncodedBuffer));

    // convert the JSON object + headers into a binary event stream message
    const binary = eventStreamMarshaller.marshall(audioEventMessage);

    return binary;
  };

  const streamAudioToWebSocket = (userMediaStream) => {
    // let's get the mic input from the browser, via the microphone-stream module
    const micStream = new MicrophoneStream();

    micStream.on('format', function(data) {
      setPlay(true);
      setInputSampleRate(data.sampleRate);
    });

    micStream.setStream(userMediaStream);

    // Pre-signed URLs are a way to authenticate a request (or WebSocket connection, in this case)
    // via Query Parameters. Learn more: https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-query-string-auth.html
    const url = createPresignedUrl();

    // open up our WebSocket connection
    const socket = new WebSocket(url);
    socket.binaryType = 'arraybuffer';

    // when we get audio data from the mic, send it to the WebSocket if possible
    socket.onopen = function() {
      micStream.on('data', function(rawAudioChunk) {
        // the audio stream is raw audio bytes. Transcribe expects PCM with additional metadata, encoded as binary
        const binary = convertAudioToBinaryMessage(rawAudioChunk);

        if (socket.readyState === socket.OPEN) {
          socket.send(binary);
        }
      });
    };

    // handle inbound messages from Amazon Transcribe
    socket.onmessage = function(message) {
      // convert the binary event stream message to JSON
      const messageWrapper = eventStreamMarshaller.unmarshall(Buffer.from(message.data));
      const messageBody = JSON.parse(String.fromCharCode(...messageWrapper.body));
      if (messageWrapper.headers[':message-type'].value === 'event') {
        handleEventStreamMessage(messageBody);
      } else {
        console.error(messageBody.Message);
        stop(socket);
      }
    };

    socket.onerror = function() {
      stop(socket);
    };

    socket.onclose = function(closeEvent) {
      micStream.stop();

      // need to understand

      // the close event immediately follows the error event; only handle one.
      //   if (!socketError && !transcribeException) {
      //     if (closeEvent.code != 1000) {
      //       showError(
      //         '</i><strong>Streaming Exception</strong><br>' + closeEvent.reason
      //       );
      //     }
      //     toggleStartStop();
      //   }
    };

    setWebSocket(socket);
  };
  const handleStart = () => {
    // first we get the microphone input from the browser (as a promise)...
    window.navigator.mediaDevices
      .getUserMedia({
        video: false,
        audio: true,
      })
    // ...then we convert the mic stream to binary event stream messages when the promise resolves
      .then(streamAudioToWebSocket)
      .catch(function(error) {});
  };
  useEffect(() => {
    reset(initialValues);
    setNotes(notesData.noteText);
  }, [notesData]);

  const onSubmit = (data) => {
    !notes && setValidateNotes(true);
    if (data?.eligibleStatus?.id && eligibiltyScrubScreen) {
      setStatusValidateData(false);
    } else if (eligibiltyScrubScreen) {
      setStatusValidateData(true);
    }
    if (eligibiltyScrubScreen && data?.eligibleStatus?.value && data?.addaNote) {
      const filteredNote = data.addaNote ? filter.clean(data.addaNote) : "";
      const text = filteredNote ? filteredNote.replace(/\*/g, "") : "";
      dispatchRecordFormatSystemNotes(text, data);
    } else if (data?.addaNote && !eligibiltyScrubScreen) {
      // dispatch(SubmissionStart())
      const filteredNote = data.addaNote ? filter.clean(data.addaNote) : '';
      const text = filteredNote ? filteredNote.replace(/\*/g, '') : '';
      dispatchRecordFormatSystemNotes(text);
    }
  };

  const handleSetNotes = (value) => {
    for (const i in profinityWords) {
      if (value === profinityWords[i] && value.length > 1) {
        const replacedWord =
          value.length === 2 ?
            value.replace(value, '**') :
            value.length === 3 ?
              value.replace(value, '***') :
              value.replace(value, '****');
        setNotes(replacedWord);
        break;
      }
    }
  };
  const debouncedSave = useCallback(
    debounce(
      (nextValue) =>
        nextValue.length <= 4 ?
          handleSetNotes(nextValue) : // : nextValue.length > 1
          setNotes(filter.clean(nextValue)),
      // : setNotes(nextValue),
      2000,
    ),
    [],
  );
  const handleFilter = (value) => {
    setCharLimitMsg(true);
    const nextValue = value;
    setNotes(nextValue);
    nextValue && debouncedSave(nextValue);
  };
  const handleClose = () => {
    setValidateNotes(false);
    setCancel(true);
    transcription = '';
    setNotes('');
    stop(webSocket);
  };
  const handleSave = () => {
    setPlay(false);
    stop(webSocket);
    !notes && setValidateNotes(true);
  };
  useEffect(() => {
    if (!notes) {
      debouncedSave.cancel();
    }
  }, [notes]);

  return (
    <>
      <form noValidate onSubmit={handleSubmit(onSubmit)}>
        <div className="col-12">
          { eligibiltyScrubScreen &&
            <div className="form-row new-standard-textfields">
              <div className="col-md-4 col-xl-4  col-sm-6 form-group">
                <FormControl margin="dense" variant="outlined" fullWidth>
                  <Controller
                    render={(props) => (
                      <GuiAutoComplete
                        {...props}
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        id="eligibleStatus"
                        options={handleGetData(dropDownData,REVIEW_STATUS) || []}
                        size="small"
                        autoHighlight
                        getOptionLabel={(option) => {
                          return option && option.value ? option.value : "";
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            className={`${classes.labelName} ${classes.selectLabel}`}
                            {...params}
                            variant="outlined"
                            fullWidth
                            label="Review Status"
                            name="eligibleStatus"
                            error={statusValidateData}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            placeholder="Select Review Status"
                            required
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: "off",
                            }}
                          />
                        )}
                        onChange={(_, data) => {
                          props.onChange(data);
                          if (data?.id) {
                            setStatusValidateData(false);
                          } else {
                            setStatusValidateData(true);
                          }
                        }}
                      />
                    )}
                    name="eligibleStatus"
                    control={control}
                  />
                </FormControl>
                {statusValidateData ? (
                  <FormHelperText
                    className="ml-3"
                    style={{
                      color: "red",
                    }}
                  >
                    Reviewed Status is required
                  </FormHelperText>
                ) : null}
              </div>
            </div>
          }
          <div
            className={`${classes.specialNeeds} ${classes.notesError}  ${classes.noteblock}  new-standard-textfields`}
          >
            <TextField
              multiline={true}
              minRows={8}
              maxRows={20}
              margin="dense"
              variant="outlined"
              className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder={`Enter Notes`}
              spellCheck="true"
              disabled={play}
              value={notes}
              error={validateNotes || notes?.length > 500}
              onChange={(e) => handleFilter(e.target.value)}
              // inputRef={register}
              name="addaNote"
              inputRef={register({
                maxLength: {
                  value: 500,
                  message: "Cannot exceed 500 characters",
                },
              })}
              inputProps={{
                spellCheck: true,
                lang: "en",
                maxLength: 500,
              }}
              fullWidth={true}
            />
            {!errors?.addaNote && notes?.length > 0 && notes?.length < 500 && charLimitMsg ? (
              <div className="validation-text">
                <FormHelperText variant="outlined">
                  Allows {500 - notes?.length} Characters Only.
                </FormHelperText>
              </div>
            ) : null}
            {notes?.length > 0 && notes?.length > 500 ? (
              <FormHelperText className="ml-3">Note cannot exceed 500 characters</FormHelperText>
            ) : null}
            {validateNotes ? (
              <FormHelperText
                className="ml-3"
                style={{
                  color: "red",
                }}
              >
                Notes is required
              </FormHelperText>
            ) : null}
            {!eligibiltyScrubScreen && (
              <>
                <Tooltip title="Start Recording">
                  <Button
                    // className={classes.micButton}
                    className={clsx(
                      classes.micButton,
                      sidePanelNotes ? classes.sidepanelMicButtonRight : classes.micButtonleft
                    )}
                    disabled={play}
                    onClick={handleStart}
                  >
                    <MicIcon />
                  </Button>
                </Tooltip>
                <Tooltip title="Stop Recording">
                  <Button
                    // className={classes.stopButton}
                    className={clsx(
                      classes.stopButton,
                      sidePanelNotes && classes.sidepanelstopButtonRight
                    )}
                    onClick={() => stop(webSocket)}
                  >
                    <StopRoundedIcon />
                  </Button>
                </Tooltip>
              </>
            )}
          </div>
          {!sidePanelNotes && (
            <div>
              <div className="d-flex justify-content-center new-standard-textfields mt-3">
                <Button
                  onClick={() => handleClose()}
                  variant="outlined"
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                >
                  Reset
                </Button>
                <Button
                  type="submit"
                  variant="outlined"
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                  onClick={() => {
                    throttle(handleSave, 3000);
                  }}
                  // disabled={
                  //   disableByRoleAccess ? false : (
                  //     (!W8disabledByRole?.add ||
                  //   !W8disabledByRole?.edit ||
                  //   !W32disabledByRole?.add ||
                  //   !W32disabledByRole?.edit))
                  // }
                  // disabled={enabledSubmission}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {sidePanelNotes && (
            <div className={`${clsx(classes1.iconButtons)}`}>
              <Tooltip title="Cancel">
                <Button
                  // variant="contained"
                  onClick={() => handleClose()}
                  className={`${clsx(classes1.cancelCloseIcon, classes1.iconWidth)} pr-0`}
                >
                  <CloseIcon />
                </Button>
              </Tooltip>
              <Tooltip title="Save">
                <Button
                  // variant="contained"
                  type="submit"
                  onClick={() => setPlay(false)}
                  className={`${clsx(classes1.saveCheckIcon, classes1.iconWidth)} pl-0`}
                  disabled={isLoading || enabledSubmission}
                  // disabled={notes?.length ? notes.length >= 250 : false}
                >
                  <Check />
                </Button>
              </Tooltip>
            </div>
          )}
        </div>
      </form>
      {(isLoading || clientisLoading) && <PageLoader />}
      {(errorMsg || clienterrorMsg) && <ErrorSnackbar errorMsg={errorMsg || clienterrorMsg} />}
      {(successMsg || clientsuccessMsg) && (
        <SuccessSnackbar successMsg={successMsg || clientsuccessMsg} />
      )}
    </>
  );
}
function createPresignedUrl() {
  const endpoint = 'transcribestreaming.' + region + '.amazonaws.com:8443';

  // get a preauthenticated URL that we can use to establish our WebSocket
  return v4.createPresignedURL(
    'GET',
    endpoint,
    '/stream-transcription-websocket',
    'transcribe',
    crypto.createHash('sha256').update('', 'utf8').digest('hex'),
    {
      key: REACT_APP_ACCESS_KEY,
      secret: REACT_APP_SECRET_KEY,
      //   sessionToken: $('#session_token').val(),
      protocol: 'wss',
      expires: 15,
      region: region,
      query: 'language-code=' + languageCode + '&media-encoding=pcm&sample-rate=' + sampleRate,
    },
  );
}
